/**
 * Maps Retsinformation short-name prefixes (e.g. "BEK nr …") to document_type_id values
 * used by {@link documentTypeMapping}. Fallback when link extra_metadata lacks enrichment.
 */
const PREFIX_TO_DOCUMENT_TYPE_ID: Record<string, string> = {
  LOV: "10",
  LBK: "30",
  BEK: "60",
  VEJ: "180",
  SKR: "200",
};

/** Resolve document type id from a legislation short name / display label prefix. */
export function resolveLegislationDocumentTypeIdFromLabel(
  label?: string | null
): string | undefined {
  const trimmed = label?.trim();
  if (!trimmed) return undefined;

  const match = trimmed.match(/^([A-Za-zÆØÅæøå]+)\s+nr\b/i);
  if (!match) return undefined;

  return PREFIX_TO_DOCUMENT_TYPE_ID[match[1].toUpperCase()];
}
